import React from 'react';
import { Link } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const PageView = props => {
  let { pageClassName, pageLinkClassName } = props;
  const {
    page,
    isCurrentPage,
    activeClassName,
    activeLinkClassName,
    getEventListener,
    pageSelectedHandler,
    extraAriaContext
  } = props;

  let ariaLabel = props.ariaLabel
    || `Page ${
      page
    }${extraAriaContext ? ` ${extraAriaContext}` : ''}`;
  let ariaCurrent = null;

  if (isCurrentPage) {
    ariaCurrent = 'page';

    ariaLabel = props.ariaLabel || `Page ${page} is your current page`;

    if (typeof pageClassName !== 'undefined') {
      pageClassName = `${pageClassName} ${activeClassName}`;
    } else {
      pageClassName = activeClassName;
    }

    if (typeof pageLinkClassName !== 'undefined') {
      if (typeof activeLinkClassName !== 'undefined') {
        pageLinkClassName = `${pageLinkClassName} ${activeLinkClassName}`;
      }
    } else {
      pageLinkClassName = activeLinkClassName;
    }
  }

  return (
    <li className={pageClassName}>
      <Link
        _hover={{ textDecoration: 'none', color: 'white', bgColor: 'greyScale.800' }}
        aria-current={ariaCurrent}
        aria-label={ariaLabel}
        bgColor={isCurrentPage ? 'greyScale.300' : 'white'}
        borderRadius="10%"
        mx={1}
        p={2}
        role="button"
        tabIndex="0"
        onKeyPress={pageSelectedHandler}
        {...getEventListener(pageSelectedHandler)}
      >
        {page}
      </Link>
    </li>
  );
};

PageView.propTypes = {
  pageSelectedHandler: PropTypes.func.isRequired,
  isCurrentPage: PropTypes.bool.isRequired,
  pageClassName: PropTypes.string,
  pageLinkClassName: PropTypes.string,
  activeClassName: PropTypes.string,
  activeLinkClassName: PropTypes.string,
  extraAriaContext: PropTypes.string,
  ariaLabel: PropTypes.string,
  page: PropTypes.number.isRequired,
  getEventListener: PropTypes.func.isRequired
};

export default PageView;
